import { H1 } from "@motley/design"
import SocialLogin from "./SocialLogin"
import {
  ApiFormWrapper,
  FormError,
  FormInput,
  FormPasswordField,
  FormSubmitButton,
} from "@/form"
import { ButtonLink, Link } from "@/base"
import { useLoginMutation } from "@/auth"

type Props = {
  email?: string
}

export default function LoginPage({ email }: Props) {
  const [login] = useLoginMutation()

  return (
    <div>
      <H1 className="text-center">Log In</H1>
      <div className="flex flex-col">
        <p className="mb-4 text-right">
          Don’t have an account yet? <Link to="/auth">Sign Up</Link>
        </p>
        <div className="mb-4">
          <SocialLogin />
        </div>
        <h4 className="mb-4 text-center">– OR –</h4>
        <ApiFormWrapper
          defaultValues={{
            email: email ?? "",
            password: "",
          }}
          action={login}
          resetOnSuccess
        >
          <FormInput
            type="email"
            name="email"
            placeholder="Email"
            required
            autoFocus
            className="mb-4 w-full"
          />
          <FormPasswordField
            name="password"
            placeholder="Password"
            isNewPassword={false}
            className="mb-4 w-full"
          />
          <FormError />
          <FormSubmitButton className="w-full">Login</FormSubmitButton>
          <p className="text-right">
            <ButtonLink variant="ghost" to="/auth/reset-password">
              Forgot your password?
            </ButtonLink>
          </p>
        </ApiFormWrapper>
      </div>
    </div>
  )
}
